/**
 * Slots for feature components delivered by the dispute parts. Each slot documents the concrete
 * props the feature implements; unimplemented parts render nothing so the detail shell stays
 * honest until the real components land.
 *
 * - Part 05 delivered DisputeActions (response/close forms) from Actions/DisputeActions.
 * - Part 08 replaces DisputeArbitrationTrackingSlot with filing/ruling tracking.
 * - Part 06 delivered DisputeLifecycleGraphSlot from Lifecycle.
 */

import type { CardDispute } from '@column/api';

export interface DisputeFeatureProps {
  dispute: CardDispute;
  canManage: boolean;
  onUpdated: () => void;
}

export { DisputeActions } from './Actions/DisputeActions';

export const DisputeArbitrationTrackingSlot: React.FC<DisputeFeatureProps> = () => null;

export { DisputeLifecycleGraph as DisputeLifecycleGraphSlot } from './Lifecycle';
export type { DisputeLifecycleGraphProps } from './Lifecycle';

export { DisputeEvidenceComposer as DisputeEvidenceComposerSlot } from './Evidence/DisputeEvidenceComposer';
export type { DisputeEvidenceComposerProps } from './Evidence/DisputeEvidenceComposer';
